import { createSlice } from '@reduxjs/toolkit';
const helpersShowSlice = createSlice({
  name: 'helpersShow',
  initialState: [],
  //NOTE filtersTYPE=[ {checkMode:"all",filtersMode:[ {column:"HI" , mode: "contains" , value: "helloworld"},... ]} , ... ]
  reducers: {
    stopShowing: (state, action) => {
      state.push(action.payload);
      return state;
    }
  }
});
export const { stopShowing } = helpersShowSlice.actions;
// export const NonFilterBacklink = gridDrawerSlice.getInitialState();
export default helpersShowSlice;
